export const financesConstants = {
  SET_PAYMENT_ORDERS_SUCCESS: 'SET_PAYMENT_ORDERS_SUCCESS',
  SET_PAYMENT_ORDERS_FAILURE: 'SET_PAYMENT_ORDERS_FAILURE',

  ADD_PAYMENTS_SUCCESS: 'ADD_PAYMENTS_SUCCESS',
  ADD_PAYMENTS_FAILURE: 'ADD_PAYMENTS_FAILURE',

  SET_PAYMENTS_DATA_SUCCESS: 'SET_PAYMENTS_DATA_SUCCESS',
  SET_PAYMENTS_DATA_FAILURE: 'SET_PAYMENTS_DATA_FAILURE',

  SET_HOLD_DETAILS_SUCCESS: 'SET_HOLD_DETAILS_SUCCESS',
  SET_HOLD_DETAILS_FAILURE: 'SET_HOLD_DETAILS_FAILURE',

  SET_HOLD_DETAILS_SETTINGS_SUCCESS: 'SET_HOLD_DETAILS_SETTINGS_SUCCESS',
  SET_HOLD_DETAILS_SETTINGS_FAILURE: 'SET_HOLD_DETAILS_SETTINGS_FAILURE',

  REDIRECT_TO_PAYMENTS_DATA: 'REDIRECT_TO_PAYMENTS_DATA',
  CLEAR_REDIRECT_TO_PAYMENTS_DATA: 'CLEAR_REDIRECT_TO_PAYMENTS_DATA',

  PAYMENT_CANCEL_REQUESTED: 'PAYMENT_CANCEL_REQUESTED',
  PAYMENT_CANCEL_SUCCESS: 'PAYMENT_CANCEL_SUCCESS',
  PAYMENT_CANCEL_FAILURE: 'PAYMENT_CANCEL_FAILURE',

  CLEAR_ERROR: 'finances/CLEAR_ERROR',
};
